<template>
  <div
    ref="qrCodeDiv"
    class="v-qrCodeDiv">

  </div>
</template>

<script>
export default {
  name: 'VQrcode',
  props: {
    url: {
      type: String,
      default: ''
    },
    option:{
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {
      qrcode : null
    }
  },
  watch: {
    url:{
      handler(val){
        val && this.createQrcode()
      }
    }
  },
  mounted () {
    import('qrcodejs2').then(e=>{
      window.QRCode = e.default
      if(this.url){
        this.$nextTick(() => {
          this.createQrcode()
        })
      }
    }).catch(err=>{

    })
  },
  beforeDestroy () {
    this.qrcode && this.qrcode.clear()
  },
  methods: {
    createQrcode(){
      this.$nextTick(() => {
        if(this.qrcode){
          this.qrcode.clear()
          this.qrcode.makeCode(this.url)
        }else{
          this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
            width: this.option.width || 150, //宽度
            height: this.option.height || 150,  // 高度
            text: this.url,      // 二维码内容
            colorDark: this.option.colorDark || '#012A63', //二维碼颜色
            colorLight: this.option.colorLight || '#fff',   //二维碼背景色
            correctLevel: QRCode.CorrectLevel.M //容错率，L/M/H
          })
        }
      })
    },
    cleanCode(){
      this.$refs.qrCodeDiv.innerHTML = ''
    }
  }
}
</script>
